import React from 'react';
import { Route, Switch } from 'react-router-dom';
import List from './List';

export default function Configuration() {

    return (
        <Switch>
            <Route exact path={"/apps/list/:appId/solo/configuration/list"} component={List}></Route>
        </Switch>
    )
}